import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { get } from "../requests/home";
import { createSignal } from "solid-js";

export default function useHome() {
  const [fetching, setFetching] = createSignal(false);
  const [currentAppointments, setCurrentAppointments] = createSignal([]);

  const onFetch = async () => {
    setFetching(true);
    try {
      const data = await get();
      setCurrentAppointments(data.current);
    } catch(error) {
      setCurrentAppointments([]);
    } finally {
      setFetching(false);
    }
  }

  return {
    fetching,
    currentAppointments,
    onFetch,
  };
}
